import axios from "axios";
const backendURL = "https://willsguru.com.au/willsguru2024/public";
// const backendURL = "http://localhost/beyond/public";
// const backendURL = "https://847b-2402-a00-192-7fd6-d99a-d9f3-c004-90d8.ngrok-free.app/";

export const InquiryForm = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/inquiry`, data)
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};

export const RegisterForm = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/register`, data)
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};

export const LoginForm = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/login`, data)
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};

export const ForgetForm = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/forgot-password`, data)
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const ResetPasswordData = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/reset-password`, data)
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error.response ? error.response.data : error.message);
      });
  });
};
export const ProfileForm = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/update-profile`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const EditPersonalDetails = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/edit-personal-details`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const AddPartner = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/add-partner`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const AddChild = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/add-child`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const AddPet = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/add-pet`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};

export const EditChild = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/update-child`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};

export const EditPet = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/edit-pet`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const EditAssets = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/edit-asset`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const AddAssets = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/save-asset`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const AddBeneficiary = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/add-beneficiaries`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const AddExecutor = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/add-executor`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const SaveExecutor = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/save-executor`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const SaveCharity = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/save-charity`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const ForgetPassword = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/change-password`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const RemoveAccount = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/remove-your-account`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const RemoveChild = (child_id) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${backendURL}/api/auth/remove-child`,
        { child_id },
        {
          headers: {
            Authorization: `Bearer ${token?.access_token}`,
          },
        }
      )
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const RemovePartner = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${backendURL}/api/auth/remove-partner`,
        {}, // No data payload, assuming the endpoint does not need additional data
        {
          headers: {
            Authorization: `Bearer ${token?.access_token}`,
          },
        }
      )
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};

export const RemovePet = (pet_id) => {
    const token = JSON.parse(localStorage.getItem("willguru-token"));
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${backendURL}/api/auth/remove-pet`,
          { pet_id },
          {
            headers: {
              Authorization: `Bearer ${token?.access_token}`,
            },
          }
        )
        .then((response) => {
          // Resolve the promise with the response data
          resolve(response.data);
        })
        .catch((error) => {
          // Reject the promise with the error
          reject(error);
        });
    });
  };
export const ContactPrefernce = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/contact-preferences`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const SaveGuardianList = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/save-guardian`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const ApplyDiscountCode = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/apply-discount-code`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const SaveEstateDevidedData = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/save-estate-divide-data`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const ifDiesSaveEstate = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/if-dies-save-estate`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const SaveEstateBeneficiary = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/save-estates-beneficiaries`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const SaveBeneficiaryGift = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/save-gift-for-beneficiary`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const SaveCharityGift = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/save-gift-for-charity`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const EditBeneficiaryGift = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/edit-gift-for-beneficiary`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const EditCharityGift = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/edit-gift-for-charity`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const InvitationSendToUser = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/send-invitation-to-user`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const SendMessageToAdmin = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .post(`${backendURL}/api/auth/send-note-by-user`, data, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
